import { useAtomValue } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import H1 from '@/components/base/Headings/H1';
// Components
import { currentStepAtom } from '@/components/pages/giveaway-picker/Atoms/stepsAtoms';
import { SelectAccount } from '@/components/pages/giveaway-picker/SelectAccountWrapper/components/SelectAccount';

export const SelectAccountWrapper = () => {
    const { t } = useTranslation('giveaway_picker');
    const currentStep = useAtomValue(currentStepAtom);

    if (currentStep !== 1) {
        return null;
    }

    return (
        <div data-testid="select-account-wrapper">
            <H1 className="mb-14">{t('account_selection.select_insta_account')}</H1>
            <SelectAccount />
        </div>
    );
};
